import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=5c30ac98"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style0 from "./Upload.vue?vue&type=style&index=0&id=5c30ac98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports